<div class="profile-container">
  <p-toast></p-toast>
  
  <div class="profile-header">
    <button type="button" class="back-button" (click)="goBack()">
      <i class="pi pi-arrow-left"></i>
      <span>Back</span>
    </button>
    <h1 class="page-title">Profile</h1>
  </div>

  @if (isLoading()) {
    <div class="loading-container">
      <p-progressSpinner [style]="{ width: '50px', height: '50px' }"></p-progressSpinner>
      <p class="loading-text">Loading profile...</p>
    </div>
  } @else if (error()) {
    <div class="error-container">
      <div class="error-icon">
        <i class="pi pi-exclamation-triangle"></i>
      </div>
      <h2 class="error-title">Error Loading Profile</h2>
      <p class="error-message">{{ error() }}</p>
      <button type="button" class="retry-button" (click)="loadProfile()">
        <i class="pi pi-refresh"></i>
        <span>Retry</span>
      </button>
    </div>
  } @else if (profile()) {
    <div class="profile-content">
      <div class="profile-card">
        <div class="profile-header-section">
          <div class="profile-icon">
            <i class="pi pi-user"></i>
          </div>
          <h2 class="profile-name">{{ getFullName() }}</h2>
          <div class="profile-badge" [class.verified]="profile()?.isEmailVerified">
            <i class="pi" [class.pi-check-circle]="profile()?.isEmailVerified" [class.pi-times-circle]="!profile()?.isEmailVerified"></i>
            <span>{{ profile()?.isEmailVerified ? 'Email Verified' : 'Email Not Verified' }}</span>
          </div>
        </div>

        <div class="profile-details">
          <div class="detail-section">
            <h3 class="section-title">Personal Information</h3>
            
            <div class="detail-item">
              <div class="detail-label">
                <i class="pi pi-user"></i>
                <span>Full Name</span>
              </div>
              <div class="detail-value">{{ getFullName() }}</div>
            </div>

            <div class="detail-item">
              <div class="detail-label">
                <i class="pi pi-envelope"></i>
                <span>Email Address</span>
              </div>
              <div class="detail-value">{{ profile()?.emailAddress || 'N/A' }}</div>
            </div>

            <div class="detail-item">
              <div class="detail-label">
                <i class="pi pi-phone"></i>
                <span>Phone Number</span>
              </div>
              <div class="detail-value">{{ profile()?.phoneNumber || 'Not provided' }}</div>
            </div>
          </div>

          <div class="detail-section">
            <h3 class="section-title">Account Information</h3>
            
            <div class="detail-item">
              <div class="detail-label">
                <i class="pi pi-id-card"></i>
                <span>Account ID</span>
              </div>
              <div class="detail-value account-id">{{ profile()?.id || 'N/A' }}</div>
            </div>

            <div class="detail-item">
              <div class="detail-label">
                <i class="pi pi-calendar"></i>
                <span>Member Since</span>
              </div>
              <div class="detail-value">{{ formatDate(profile()?.dateCreated || '') }}</div>
            </div>

            <div class="detail-item">
              <div class="detail-label">
                <i class="pi pi-shield"></i>
                <span>Account Status</span>
              </div>
              <div class="detail-value" [class.active]="profile()?.isActive" [class.inactive]="!profile()?.isActive">
                {{ profile()?.isActive ? 'Active' : 'Inactive' }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
</div>
